export default __webpack_public_path__ + "static/media/business.405f14f8.png";